export default "__VITE_ASSET__DKIw2rzB__"